import { RouterModule, Routes } from '@angular/router';

import { ContainerResolver } from './container.resolver';
import { DescriptionsComponent } from './descriptions/descriptions.component';
import { DescriptionResolver } from './descriptions/description.resolver';
import { DebugComponent } from './debug/debug.component';
import { ErrorComponent } from './errors/error.component';
import { HealthComponent } from './health/health.component';
import { Help_GuideComponent } from './help_guides/help_guides.component';
import { LaunchComponent } from './home/launch.component';
import { NgModule } from '@angular/core';
import { ServerResolver } from './server.resolver';
import { UsageReportingComponent } from './usage-reporting/usage-reporting.component';
import { UsageReportingResolver } from './usage-reporting/usage-reporting.resolver';
import { UserGuard } from './user.guard';
import { UserResolver } from './user.resolver';

const routes: Routes = [
  {
    path: 'help_guides',
    canActivate: [UserGuard],
    component: Help_GuideComponent,
  },
  {
    path: 'launch',
    canActivate: [UserGuard],
    component: LaunchComponent,
    resolve: {
      user: UserResolver,
      containers: ContainerResolver,
      server: ServerResolver,
    },
  },
  {
    path: 'notebook-descriptions',
    component: DescriptionsComponent,
    resolve: {
      description: DescriptionResolver,
    },
  },
  {
    path: 'usage-reporting',
    canActivate: [UserGuard],
    component: UsageReportingComponent,
    resolve: {
      usageData: UsageReportingResolver,
      user: UserResolver,
    },
  },
  {
    path: 'launch/health',
    component: HealthComponent,
  },
  {
    path: 'launch/debug',
    canActivate: [UserGuard],
    component: DebugComponent,
    resolve: {
      user: UserResolver,
      containers: ContainerResolver,
      server: ServerResolver,
    },
  },
  {
    path: 'error/:code',
    component: ErrorComponent,
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
